export const SET_CURRENT_ACCOUNT_ID = 'SET_CURRENT_ACCOUNT_ID';
export const SET_CURRENT_ACCOUNT = 'SET_CURRENT_ACCOUNT';
export const SET_CURRENT_ACCOUNT_SETTINGS = 'SET_CURRENT_ACCOUNT_SETTINGS';
export const SET_CURRENT_ACCOUNT_USER = 'SET_CURRENT_ACCOUNT_USER';
export const SET_CURRENT_ACCOUNT_ITEM_PERMISSIONS = 'SET_CURRENT_ACCOUNT_ITEM_PERMISSIONS';
export const SET_CURRENT_ACCOUNT_PERMISSIONS = 'SET_CURRENT_ACCOUNT_PERMISSIONS';
export const SET_CURRENT_ACCOUNT_FEATURE_FLAGS = 'SET_CURRENT_ACCOUNT_FEATURE_FLAGS';
export const SET_CURRENT_ACCOUNT_USER_GROUPS = 'SET_CURRENT_ACCOUNT_USER_GROUPS';
export const SET_CURRENT_ACCOUNT_IS_PAUSED = 'SET_CURRENT_ACCOUNT_IS_PAUSED';

export const SET_TIMEZONES_LIST = 'SET_TIMEZONES_LIST';

export const SET_RECENTLY_USED_TAGS = 'SET_RECENTLY_USED_TAGS';

export const SET_COMPLETED_CAMPAIGNS_RECORDS_WITHOUT_STATS = 'SET_COMPLETED_CAMPAIGNS_RECORDS_WITHOUT_STATS';

export const SET_TARGETS_WITH_NO_STATS = 'SET_TARGETS_WITH_NO_STATS';

export const SET_PING_TREE_TARGETS_WITH_NO_STATS = 'SET_PING_TREE_TARGETS_WITH_NO_STATS';

export const SET_AFFILIATES = 'SET_AFFILIATES';
export const SET_BUYERS = 'SET_BUYERS';
export const SET_CALL_PLANS = 'SET_CALL_PLANS';

export const RESET = 'reset';